
import '../Styles/LangChange.css';
function LangChange(){
    const changeLang = (lang) => {
        localStorage.setItem("lang",lang);
    };
    return(
        <div>
            <button className='langButton' onClick={()=>changeLang("en")}>English</button>
            <button className='langButton' onClick={()=>changeLang("ar")}>عربي</button>
        </div>
    );
}
export default LangChange;